let unreadChatCount = 0;
let selectedAgent = null;
let currentChannel = 'general';
let wgeAgentDetailsExpanded = false;

const wgeDefaultChatMessage = 'WatchTower Ops General Support Channel active. Select an Operative or type your inquiry below.';

const WGE_CHAT_STORAGE_KEY = 'wge_command_center_chat_state_v1';
const WGE_CHAT_SESSION_ID_KEY = 'wge_command_center_session_id_v1';
const WGE_CHAT_STATE_VERSION = 1;
const WGE_HISTORY_LIMIT_PER_CHANNEL = 40;
const WGE_MESSAGE_TEXT_LIMIT = 1500;
const WGE_DISPATCH_ENDPOINT = 'https://api.thewatchtowerops.com/dispatch';
const WGE_REPLIES_ENDPOINT = 'https://api.thewatchtowerops.com/replies';
const WGE_ATTACHMENT_CAPABILITIES_ENDPOINT = 'https://api.thewatchtowerops.com/attachments/capabilities';
const WGE_ATTACHMENT_PREPARE_ENDPOINT = 'https://api.thewatchtowerops.com/attachments/prepare';
const WGE_ATTACHMENT_API_BASE = 'https://api.thewatchtowerops.com';
const WGE_ATTACHMENT_MAX_FILES = 5;
const WGE_ATTACHMENT_MAX_FILE_BYTES = 40 * 1024 * 1024;
const WGE_ATTACHMENT_MAX_TOTAL_BYTES = 40 * 1024 * 1024;
const WGE_ATTACHMENT_POLL_INTERVAL_MS = 2500;
const WGE_ATTACHMENT_POLL_MAX_ATTEMPTS = 48;
const WGE_ATTACHMENT_ALLOWED_TYPES = new Map([
  ['image/jpeg', new Set(['.jpg', '.jpeg'])],
  ['image/png', new Set(['.png'])],
  ['image/webp', new Set(['.webp'])],
  ['application/pdf', new Set(['.pdf'])],
  ['video/mp4', new Set(['.mp4'])],
  ['video/quicktime', new Set(['.mov'])]
]);
const WGE_DISPATCH_TIMEOUT_MS = 12000;
const WGE_NAVIGATION_ACTION_LIMIT = 2;
const WGE_NAVIGATION_LABEL_LIMIT = 120;
const WGE_NAVIGATION_URL_LIMIT = 600;

const WGE_NAVIGATION_ALLOWED_HOSTS = new Set([
  'thewatchtowerops.com',
  'www.thewatchtowerops.com',
  'discord.gg',
  'discord.com',
  'www.discord.com'
]);
const WGE_REPLY_REQUEST_TIMEOUT_MS = 10000;
const WGE_REPLY_POLL_INTERVAL_MS = 6000;
const WGE_REPLY_SEEN_IDS_KEY = 'wge_command_center_seen_reply_ids_v1';
const WGE_REPLY_LAST_CREATED_AT_KEY = 'wge_command_center_last_reply_created_at_v1';

let wgeDispatchInProgress = false;
let wgeReplyPollingTimer = null;
let wgeReplyPollInProgress = false;
let wgeAttachmentBatchInProgress = false;
let wgeSeenReplyIds = loadWgeSeenReplyIds();

const WGE_CALENDLY_URL = 'https://calendly.com/ceo-thewatchtowerops/30min';
const WGE_CALENDLY_CSS_URL = 'https://assets.calendly.com/assets/external/widget.css';
const WGE_CALENDLY_JS_URL = 'https://assets.calendly.com/assets/external/widget.js';
const WGE_CALENDLY_CSS_ID = 'wge-calendly-widget-css';
const WGE_CALENDLY_SCRIPT_ID = 'wge-calendly-widget-js';
let wgeCalendlyLoadingPromise = null;
let wgeCalendlyInlineRendered = false;


const WGE_OKAMI_REQUEST_TYPE = 'partner_marketing_request';
const WGE_OKAMI_ROUTING_LANE = 'marketing_partnership';
const WGE_ROLE_NOTE_HIDE_DELAY_MS = 2200;

let wgeRoleNoteHideTimer = null;
let wgeOkamiRequestInProgress = false;
let wgeLastOkamiRequestTriggerAt = 0;

const wgeAgentProfiles = {
  Ambar: {
    name: 'AMBAR',
    role: 'TRADE PROTECTION & ESCROW',
    title: 'Trade Protection & Escrow Guide',
    avatar: 'https://cdn.shopify.com/s/files/1/0594/8512/6728/files/Ambar.jpg?v=1778873245',
    mobileDescription: 'Escrow payments, buyer-seller handoff, verified transfer, and seller payout release.',
    description: 'Best for escrow payment steps, buyer-seller handoff, verified account transfer, and seller payout release after delivery is confirmed. Share your trade stage and AMBAR will guide the next safe move.',
    intro: 'AMBAR support lane active. Share your trade stage, escrow question, or payout release status below.'
  },
  Veto: {
    name: 'VETO',
    role: 'ELITE OPS & DIAGNOSTIC',
    title: 'Elite Ops & Diagnostic Specialist',
    avatar: 'https://cdn.shopify.com/s/files/1/0594/8512/6728/files/VETO_update.webp?v=1780402490',
    mobileDescription: 'Elite Ops progress, diagnostics, shelter optimization, and mission execution.',
    description: 'Best for Elite Concierge Management progress, Tactical Diagnostic & Audit, shelter optimization, gameplay objectives, and mission execution. Share your current goal or service stage so we can identify the next tactical move.',
    intro: 'VETO support lane active. Share your mission objective, audit request, or Elite Ops service stage below.'
  },
  Leo: {
    name: 'LEO',
    role: 'MENTORSHIP & RESOURCE SUPPORT',
    title: 'Mentorship & Resource Support Specialist',
    avatar: 'https://cdn.shopify.com/s/files/1/0594/8512/6728/files/VETO.jpg?v=1778874082',
    mobileDescription: 'Mentorship, resource support, scheduling, energy conversion, and player guidance.',
    description: 'Best for VIP 1-on-1 Mentorship, energy conversion, service scheduling, routine updates, and player guidance. Share what you want to improve or organize, and we will help set the next step.',
    intro: 'LEO support lane active. Share your mentorship, scheduling, resource, or player guidance request below.'
  },
  Alex: {
    name: 'ALEX',
    role: 'ACCOUNT & GUIDANCE',
    title: 'Account & Guidance Specialist',
    avatar: 'https://cdn.shopify.com/s/files/1/0594/8512/6728/files/ALEX.jpg?v=1778873245',
    mobileDescription: 'Account review, custom asset sourcing, verification, access issues, and complex cases.',
    description: 'Best for account review, custom asset sourcing, verified asset checks, access issues, and complex support cases. Share what you are looking for or what needs verification, and we will guide the next safe step.',
    intro: 'ALEX support lane active. Share your account review, sourcing request, verification question, or access issue below.'
  }
};

const wgeChannelHistories = {
  general: [
    {
      type: 'agent',
      text: wgeDefaultChatMessage
    }
  ],
  Ambar: [],
  Veto: [],
  Leo: [],
  Alex: []
};

function getWgeValidChannelKeys() {
  return ['general', 'Ambar', 'Veto', 'Leo', 'Alex'];
}

function isWgeValidChannel(channelKey) {
  return getWgeValidChannelKeys().includes(channelKey);
}

function getWgeSessionId() {
  try {
    let sessionId = sessionStorage.getItem(WGE_CHAT_SESSION_ID_KEY);

    if (!sessionId) {
      const randomPart = Math.random().toString(36).slice(2, 10);
      const timePart = Date.now().toString(36);
      sessionId = 'wge_' + timePart + '_' + randomPart;
      sessionStorage.setItem(WGE_CHAT_SESSION_ID_KEY, sessionId);
    }

    return sessionId;
  } catch (error) {
    return 'wge_session_unavailable';
  }
}
function loadWgeSeenReplyIds() {
  try {
    const rawIds = sessionStorage.getItem(WGE_REPLY_SEEN_IDS_KEY);
    if (!rawIds) return new Set();

    const parsedIds = JSON.parse(rawIds);
    if (!Array.isArray(parsedIds)) return new Set();

    return new Set(
      parsedIds
        .map(id => String(id || '').trim())
        .filter(Boolean)
        .slice(-120)
    );
  } catch (error) {
    return new Set();
  }
}

function saveWgeSeenReplyIds() {
  try {
    const limitedIds = Array.from(wgeSeenReplyIds)
      .map(id => String(id || '').trim())
      .filter(Boolean)
      .slice(-120);

    wgeSeenReplyIds = new Set(limitedIds);
    sessionStorage.setItem(WGE_REPLY_SEEN_IDS_KEY, JSON.stringify(limitedIds));
  } catch (error) {
    return false;
  }

  return true;
}

function getWgeLastReplyCreatedAt() {
  try {
    return sessionStorage.getItem(WGE_REPLY_LAST_CREATED_AT_KEY) || '';
  } catch (error) {
    return '';
  }
}

function setWgeLastReplyCreatedAt(createdAt) {
  try {
    const safeCreatedAt = String(createdAt || '').trim();
    if (!safeCreatedAt) return false;

    sessionStorage.setItem(WGE_REPLY_LAST_CREATED_AT_KEY, safeCreatedAt);
  } catch (error) {
    return false;
  }

  return true;
}

function isWgeDashboardOpen() {
  const dashboard = document.getElementById('wgeDashboard');
  return Boolean(dashboard && dashboard.classList.contains('is-open'));
}

function isWgeChatViewActive() {
  const chatView = document.getElementById('view-chat');
  return Boolean(chatView && chatView.classList.contains('active'));
}

function shouldRenderWgeReplyImmediately(channelKey) {
  return isWgeChatViewActive() && getActiveChannel() === channelKey;
}

function buildWgeRepliesUrl() {
  const url = new URL(WGE_REPLIES_ENDPOINT);
  const lastReplyCreatedAt = getWgeLastReplyCreatedAt();

  url.searchParams.set('session_id', getWgeSessionId());
  url.searchParams.set('limit', '50');

  if (lastReplyCreatedAt) {
    url.searchParams.set('after_created_at', lastReplyCreatedAt);
  }

  return url.toString();
}

function formatWgeOperatorReplyText(reply) {
  const rawMessage = reply && reply.message !== undefined && reply.message !== null
    ? String(reply.message)
    : '';

  return rawMessage.slice(0, WGE_MESSAGE_TEXT_LIMIT).trim();
}

function processWgeOperatorReplies(replies) {
  if (!Array.isArray(replies) || replies.length === 0) return false;

  let unreadAdded = 0;
  let latestCreatedAt = getWgeLastReplyCreatedAt();

  replies.forEach(reply => {
    if (!reply) return;

    const replyId = String(reply.reply_id || '').trim();
    const createdAt = String(reply.created_at || '').trim();

    if (createdAt && (!latestCreatedAt || createdAt > latestCreatedAt)) {
      latestCreatedAt = createdAt;
    }

    if (!replyId || wgeSeenReplyIds.has(replyId)) return;

    const channelKey = isWgeValidChannel(reply.channel) ? reply.channel : 'general';
    const replyText = formatWgeOperatorReplyText(reply);
    const attachments = sanitizeWgeReplyAttachments(reply.attachments);

    if (!replyText && attachments.length === 0) return;

    wgeSeenReplyIds.add(replyId);
    pushToChannel(channelKey, replyText, 'operator', { attachments });

    if (shouldRenderWgeReplyImmediately(channelKey)) {
      if (replyText) appendMsg('chatArea', replyText, 'operator', false);
      if (attachments.length > 0) renderWgeOperatorAttachments('chatArea', attachments);
    } else {
      unreadAdded++;
    }
  });

  if (latestCreatedAt) {
    setWgeLastReplyCreatedAt(latestCreatedAt);
  }

  if (unreadAdded > 0) {
    unreadChatCount += unreadAdded;
    updateBadges();
  }

  saveWgeSeenReplyIds();

  return true;
}

async function fetchWgeOperatorReplies() {
  if (wgeReplyPollInProgress) return false;

  wgeReplyPollInProgress = true;

  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => {
    controller.abort();
  }, WGE_REPLY_REQUEST_TIMEOUT_MS);

  try {
    const response = await fetch(buildWgeRepliesUrl(), {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      signal: controller.signal
    });

    let data = null;

    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }

    if (!response.ok || !data || data.ok !== true || !Array.isArray(data.replies)) {
      return false;
    }

    return processWgeOperatorReplies(data.replies);
  } catch (error) {
    return false;
  } finally {
    window.clearTimeout(timeoutId);
    wgeReplyPollInProgress = false;
  }
}

function startWgeReplyPolling() {
  if (wgeReplyPollingTimer) return;

  fetchWgeOperatorReplies();

  wgeReplyPollingTimer = window.setInterval(() => {
    if (document.hidden) return;
    fetchWgeOperatorReplies();
  }, WGE_REPLY_POLL_INTERVAL_MS);
}

function stopWgeReplyPolling() {
  if (!wgeReplyPollingTimer) return;

  window.clearInterval(wgeReplyPollingTimer);
  wgeReplyPollingTimer = null;
}

function triggerWgeReplyCheckSoon(delayMs) {
  window.setTimeout(() => {
    fetchWgeOperatorReplies();
  }, Number(delayMs || 1200));
}
function sanitizeWgeNavigationActions(actions) {
  if (!Array.isArray(actions)) return [];

  const safeActions = [];
  const seenActionIds = new Set();
  const seenUrls = new Set();

  for (const action of actions) {
    if (safeActions.length >= WGE_NAVIGATION_ACTION_LIMIT) break;
    if (!action || typeof action !== 'object') continue;

    const rawActionId =
      action.action_id !== undefined && action.action_id !== null
        ? action.action_id
        : action.actionId;

    const actionId = String(rawActionId || '').trim();

    const label = String(action.label || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, WGE_NAVIGATION_LABEL_LIMIT);

    const rawUrl = String(action.url || '').trim();

    if (!/^[A-Za-z0-9._:-]{1,100}$/.test(actionId)) continue;
    if (!label || !rawUrl || rawUrl.length > WGE_NAVIGATION_URL_LIMIT) continue;
    if (/[\s\\<>"']/.test(rawUrl)) continue;

    let parsedUrl;

    try {
      parsedUrl = new URL(rawUrl);
    } catch (error) {
      continue;
    }

    const hostname = String(parsedUrl.hostname || '')
      .trim()
      .toLowerCase()
      .replace(/\.$/, '');

    if (parsedUrl.protocol !== 'https:') continue;
    if (!hostname || !WGE_NAVIGATION_ALLOWED_HOSTS.has(hostname)) continue;
    if (parsedUrl.username || parsedUrl.password) continue;
    if (parsedUrl.port && parsedUrl.port !== '443') continue;

    const actionKey = actionId.toLowerCase();
    const urlKey = rawUrl.toLowerCase();

    if (seenActionIds.has(actionKey) || seenUrls.has(urlKey)) continue;

    seenActionIds.add(actionKey);
    seenUrls.add(urlKey);

    safeActions.push({
      actionId,
      label,
      url: rawUrl
    });
  }

  return safeActions;
}
function sanitizeWgeReplyAttachments(attachments) {
  if (!Array.isArray(attachments)) return [];

  const safe = [];

  for (const item of attachments) {
    if (safe.length >= WGE_ATTACHMENT_MAX_FILES) break;
    if (!item || typeof item !== 'object') continue;

    const attachmentId = String(item.attachment_id || item.attachmentId || '').trim();
    const name = String(item.name || '').trim().slice(0, 180);
    const contentType = String(item.content_type || item.contentType || '').trim().toLowerCase();
    const sizeBytes = Number(item.size_bytes || item.sizeBytes || 0);
    const rawUrl = String(item.download_url || item.downloadUrl || '').trim();
    const rawPreviewUrl = String(item.preview_url || item.previewUrl || '').trim();

    if (!/^WTA-\d{8}-[A-Z0-9]{16}$/.test(attachmentId)) continue;
    if (!name || !WGE_ATTACHMENT_ALLOWED_TYPES.has(contentType)) continue;
    if (!Number.isFinite(sizeBytes) || sizeBytes <= 0 || sizeBytes > WGE_ATTACHMENT_MAX_FILE_BYTES) continue;

    let parsedUrl;
    try {
      parsedUrl = new URL(rawUrl);
    } catch (error) {
      continue;
    }

    if (parsedUrl.protocol !== 'https:') continue;
    if (parsedUrl.hostname !== 'api.thewatchtowerops.com') continue;
    if (parsedUrl.pathname !== '/attachments/' + attachmentId + '/download') continue;
    if (parsedUrl.searchParams.get('session_id') !== getWgeSessionId()) continue;

    let previewUrl = '';
    if (rawPreviewUrl) {
      try {
        const parsedPreviewUrl = new URL(rawPreviewUrl);
        if (
          parsedPreviewUrl.protocol === 'https:' &&
          parsedPreviewUrl.hostname === 'api.thewatchtowerops.com' &&
          parsedPreviewUrl.pathname === '/attachments/' + attachmentId + '/preview' &&
          parsedPreviewUrl.searchParams.get('session_id') === getWgeSessionId()
        ) {
          previewUrl = parsedPreviewUrl.toString();
        }
      } catch (error) {
        previewUrl = '';
      }
    }

    safe.push({
      attachmentId,
      name,
      contentType,
      sizeBytes,
      downloadUrl: parsedUrl.toString(),
      previewUrl
    });
  }

  return safe;
}

function sanitizeWgeStoredMessage(item) {
  const allowedTypes = ['agent', 'user', 'document', 'ai', 'operator', 'system'];
  const rawType = item && typeof item.type === 'string' ? item.type : 'agent';
  const type = allowedTypes.includes(rawType) ? rawType : 'agent';
  const rawText = item && item.text !== undefined && item.text !== null ? String(item.text) : '';
  const text = rawText.slice(0, WGE_MESSAGE_TEXT_LIMIT);
  const timestamp = item && Number.isFinite(Number(item.timestamp)) ? Number(item.timestamp) : Date.now();
  const rawStatusText = item && item.statusText !== undefined && item.statusText !== null ? String(item.statusText) : '';
  const rawTicketId = item && item.ticketId !== undefined && item.ticketId !== null ? String(item.ticketId) : '';
  const actions = sanitizeWgeNavigationActions(item && item.actions);
  const attachments = sanitizeWgeReplyAttachments(item && item.attachments);

  return {
    type,
    text,
    timestamp,
    statusText: rawStatusText.slice(0, 160),
    ticketId: rawTicketId.slice(0, 48),
    actions,
    attachments
  };
}

function trimWgeChannelHistory(history) {
  if (!Array.isArray(history)) return [];

  return history
    .map(item => sanitizeWgeStoredMessage(item))
    .filter(item => item.text.trim() !== '' || item.attachments.length > 0)
    .slice(-WGE_HISTORY_LIMIT_PER_CHANNEL);
}

function getSerializableWgeHistories() {
  const histories = {};

  getWgeValidChannelKeys().forEach(channelKey => {
    histories[channelKey] = trimWgeChannelHistory(wgeChannelHistories[channelKey] || []);
  });

  if (!histories.general || histories.general.length === 0) {
    histories.general = [sanitizeWgeStoredMessage({ type: 'agent', text: wgeDefaultChatMessage })];
  }

  return histories;
}

function saveWgeChatState() {
  try {
    const safeCurrentChannel = isWgeValidChannel(currentChannel) ? currentChannel : 'general';
    const safeSelectedAgent = selectedAgent && wgeAgentProfiles[selectedAgent] ? selectedAgent : null;

    const state = {
      version: WGE_CHAT_STATE_VERSION,
      sessionId: getWgeSessionId(),
      updatedAt: Date.now(),
      currentChannel: safeCurrentChannel,
      selectedAgent: safeSelectedAgent,
      wgeAgentDetailsExpanded: Boolean(wgeAgentDetailsExpanded),
      histories: getSerializableWgeHistories()
    };

    sessionStorage.setItem(WGE_CHAT_STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    return false;
  }

  return true;
}

function loadWgeChatState() {
  try {
    const rawState = sessionStorage.getItem(WGE_CHAT_STORAGE_KEY);
    if (!rawState) return null;

    const state = JSON.parse(rawState);
    if (!state || state.version !== WGE_CHAT_STATE_VERSION || !state.histories) return null;

    return state;
  } catch (error) {
    return null;
  }
}

function restoreWgeChatState() {
  const state = loadWgeChatState();

  if (!state) {
    ensureChannelHistory('general');
    saveWgeChatState();
    return;
  }

  getWgeValidChannelKeys().forEach(channelKey => {
    const restoredHistory = trimWgeChannelHistory(state.histories[channelKey] || []);
    wgeChannelHistories[channelKey] = restoredHistory;
  });

  if (!wgeChannelHistories.general || wgeChannelHistories.general.length === 0) {
    wgeChannelHistories.general = [sanitizeWgeStoredMessage({ type: 'agent', text: wgeDefaultChatMessage })];
  }

  const restoredChannel = isWgeValidChannel(state.currentChannel) ? state.currentChannel : 'general';
  currentChannel = restoredChannel;
  selectedAgent = wgeAgentProfiles[restoredChannel] ? restoredChannel : null;
  wgeAgentDetailsExpanded = Boolean(state.wgeAgentDetailsExpanded) && Boolean(selectedAgent);

  document.querySelectorAll('.wge-chat-agents-top img').forEach(img => img.classList.remove('active'));

  if (selectedAgent) {
    const targetImg = document.getElementById('avatar-' + selectedAgent);
    if (targetImg) targetImg.classList.add('active');
    updateAgentInfoCard(selectedAgent);
  } else {
    const card = document.getElementById('agentInfoCard');
    const avatar = document.getElementById('agentCardAvatar');
    const name = document.getElementById('agentCardName');
    const role = document.getElementById('agentCardRole');
    const desc = document.getElementById('agentCardDesc');

    if (card) {
      card.classList.remove('is-visible');
      card.classList.remove('is-expanded');
    }

    if (avatar) avatar.src = wgeAgentProfiles.Ambar.avatar;
    if (name) name.innerText = 'WATCHTOWER OPS';
    if (role) role.innerText = 'General Support Channel';
    if (desc) desc.innerText = 'Select an operative to review the right support lane before sending your message.';

    updateAgentDetailsToggle();
  }

  const chatView = document.getElementById('view-chat');
  const isChatActive = chatView && chatView.classList.contains('active');

  if (isChatActive) {
    updateChatTitle();
    renderCurrentChannel();
  }

  saveWgeChatState();
}

function isMobileViewport() {
  return window.innerWidth <= 1000;
}

function getActiveChannel() {
  return currentChannel || 'general';
}

function ensureChannelHistory(channelKey) {
  const key = channelKey || 'general';

  if (!wgeChannelHistories[key]) {
    wgeChannelHistories[key] = [];
  }

  if (wgeChannelHistories[key].length === 0) {
    const profile = wgeAgentProfiles[key];

    wgeChannelHistories[key].push({
      type: 'agent',
      text: profile ? profile.intro : wgeDefaultChatMessage
    });
  }

  return wgeChannelHistories[key];
}

function handleSearch(e, el) {
  if (e.key === 'Enter' && el.value.trim() !== '') {
    window.open('https://thewatchtowerops.com/search?q=' + encodeURIComponent(el.value.trim()), '_blank');
    el.value = '';
  }
}

function loadWgeCalendlyAssets() {
  if (window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
    if (!document.getElementById(WGE_CALENDLY_CSS_ID)) {
      const existingLink = document.querySelector('link[href="' + WGE_CALENDLY_CSS_URL + '"]');

      if (existingLink) {
        existingLink.id = WGE_CALENDLY_CSS_ID;
      } else {
        const calendlyCss = document.createElement('link');
        calendlyCss.id = WGE_CALENDLY_CSS_ID;
        calendlyCss.rel = 'stylesheet';
        calendlyCss.href = WGE_CALENDLY_CSS_URL;
        document.head.appendChild(calendlyCss);
      }
    }

    return Promise.resolve();
  }

  if (wgeCalendlyLoadingPromise) {
    return wgeCalendlyLoadingPromise;
  }

  wgeCalendlyLoadingPromise = new Promise((resolve, reject) => {
    if (!document.head) {
      reject(new Error('Document head is not available for Calendly assets.'));
      return;
    }

    let cssReady = false;
    let scriptReady = false;

    function finishIfReady() {
      if (cssReady && scriptReady) {
        if (window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
          resolve();
        } else {
          reject(new Error('Calendly widget loaded but Calendly API is unavailable.'));
        }
      }
    }

    const existingLink = document.getElementById(WGE_CALENDLY_CSS_ID) || document.querySelector('link[href="' + WGE_CALENDLY_CSS_URL + '"]');

    if (existingLink) {
      existingLink.id = WGE_CALENDLY_CSS_ID;
      cssReady = true;
    } else {
      const calendlyCss = document.createElement('link');
      calendlyCss.id = WGE_CALENDLY_CSS_ID;
      calendlyCss.rel = 'stylesheet';
      calendlyCss.href = WGE_CALENDLY_CSS_URL;
      calendlyCss.onload = () => {
        cssReady = true;
        finishIfReady();
      };
      calendlyCss.onerror = () => reject(new Error('Calendly stylesheet failed to load.'));
      document.head.appendChild(calendlyCss);
    }

    const existingScript = document.getElementById(WGE_CALENDLY_SCRIPT_ID) || document.querySelector('script[src="' + WGE_CALENDLY_JS_URL + '"]');

    if (existingScript) {
      existingScript.id = WGE_CALENDLY_SCRIPT_ID;

      if (window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
        scriptReady = true;
      } else {
        existingScript.addEventListener('load', () => {
          scriptReady = true;
          finishIfReady();
        }, { once: true });
        existingScript.addEventListener('error', () => reject(new Error('Calendly script failed to load.')), { once: true });
      }
    } else {
      const calendlyScript = document.createElement('script');
      calendlyScript.id = WGE_CALENDLY_SCRIPT_ID;
      calendlyScript.src = WGE_CALENDLY_JS_URL;
      calendlyScript.async = true;
      calendlyScript.onload = () => {
        scriptReady = true;
        finishIfReady();
      };
      calendlyScript.onerror = () => reject(new Error('Calendly script failed to load.'));
      document.head.appendChild(calendlyScript);
    }

    finishIfReady();
  }).catch(error => {
    wgeCalendlyLoadingPromise = null;
    throw error;
  });

  return wgeCalendlyLoadingPromise;
}

function preloadWgeCalendlyAssets() {
  loadWgeCalendlyAssets().catch(() => false);
}

function renderWgeCalendlyInline() {
  const modal = document.getElementById('wgeCalendlyModal');
  const inlineContainer = document.getElementById('wgeCalendlyInline');
  const loading = document.getElementById('wgeCalendlyLoading');

  if (!modal || !inlineContainer) {
    window.open(WGE_CALENDLY_URL, '_blank', 'noopener');
    return Promise.resolve(false);
  }

  modal.classList.remove('is-error');

  if (loading) {
    loading.innerText = 'Loading tactical scheduler...';
  }

  if (wgeCalendlyInlineRendered && inlineContainer.children.length > 0) {
    modal.classList.add('is-loaded');
    return Promise.resolve(true);
  }

  modal.classList.remove('is-loaded');

  return loadWgeCalendlyAssets()
    .then(() => {
      if (!window.Calendly || typeof window.Calendly.initInlineWidget !== 'function') {
        throw new Error('Calendly inline API is unavailable.');
      }

      inlineContainer.innerHTML = '';

      window.Calendly.initInlineWidget({
        url: WGE_CALENDLY_URL,
        parentElement: inlineContainer
      });

      wgeCalendlyInlineRendered = true;

      setTimeout(() => {
        modal.classList.add('is-loaded');
      }, 450);

      return true;
    })
    .catch(() => {
      modal.classList.add('is-error');

      if (loading) {
        loading.innerText = 'Scheduler could not load. Opening secure booking link...';
      }

      setTimeout(() => {
        window.open(WGE_CALENDLY_URL, '_blank', 'noopener');
      }, 700);

      return false;
    });
}

function openWgeCalendlyModal() {
  const modal = document.getElementById('wgeCalendlyModal');

  if (!modal) {
    openWgeCalendlyPopup();
    return;
  }

  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('wge-calendly-modal-open');

  renderWgeCalendlyInline();
}

function closeWgeCalendlyModal() {
  const modal = document.getElementById('wgeCalendlyModal');

  if (!modal) return;

  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('wge-calendly-modal-open');
}


function setWgeOkamiRequestVisualState(isOpen) {
  const targets = document.querySelectorAll('.wge-okami-op-card');

  targets.forEach(target => {
    if (!target) return;

    if (isOpen) {
      target.classList.add('is-request-open');
    } else {
      target.classList.remove('is-request-open');
    }
  });
}

function resetWgeOkamiRequestForm() {
  const form = document.getElementById('wgeOkamiRequestForm');
  const status = document.getElementById('wgeOkamiStatus');
  const success = document.getElementById('wgeOkamiSuccess');
  const submitBtn = document.getElementById('wgeOkamiSubmitBtn');

  if (form) {
    form.hidden = false;
    form.reset();
  }

  if (status) {
    status.innerText = '';
    status.classList.remove('is-error', 'is-success');
  }

  if (success) {
    success.hidden = true;
  }

  if (submitBtn) {
    submitBtn.disabled = false;
    submitBtn.innerText = 'Submit Partner Request';
  }

  wgeOkamiRequestInProgress = false;
}

function openWgeOkamiRequestModal() {
  const modal = document.getElementById('wgeOkamiRequestModal');

  hideWgeRoleNote();

  if (!modal) return;

  modal.hidden = false;
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('wge-okami-modal-open');
  setWgeOkamiRequestVisualState(true);

  const success = document.getElementById('wgeOkamiSuccess');
  if (!success || success.hidden) {
    const status = document.getElementById('wgeOkamiStatus');
    if (status) {
      status.innerText = '';
      status.classList.remove('is-error', 'is-success');
    }
  }

  window.setTimeout(() => {
    const firstInput = document.getElementById('wgeOkamiName');
    if (firstInput && !isMobileViewport()) firstInput.focus();
  }, 180);
}

function closeWgeOkamiRequestModal() {
  const modal = document.getElementById('wgeOkamiRequestModal');

  if (!modal) return;

  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('wge-okami-modal-open');
  setWgeOkamiRequestVisualState(false);

  window.setTimeout(() => {
    if (!modal.classList.contains('is-open')) {
      modal.hidden = true;
    }
  }, 240);
}

function getWgeOkamiFieldValue(id) {
  const field = document.getElementById(id);
  return field ? String(field.value || '').trim() : '';
}

function getWgeOkamiRequestData() {
  return {
    name: getWgeOkamiFieldValue('wgeOkamiName'),
    contact: getWgeOkamiFieldValue('wgeOkamiContact'),
    inquiry_type: getWgeOkamiFieldValue('wgeOkamiType'),
    platform: getWgeOkamiFieldValue('wgeOkamiPlatform'),
    audience_size: getWgeOkamiFieldValue('wgeOkamiAudience'),
    preferred_date: getWgeOkamiFieldValue('wgeOkamiPreferredDate'),
    preferred_time: getWgeOkamiFieldValue('wgeOkamiPreferredTime'),
    timezone: getWgeOkamiFieldValue('wgeOkamiTimezone'),
    summary: getWgeOkamiFieldValue('wgeOkamiSummary')
  };
}

function validateWgeOkamiRequest(data) {
  if (!data.name) return 'Name or brand name is required.';
  if (!data.contact) return 'Email or Discord contact is required.';
  if (!data.inquiry_type) return 'Inquiry type is required.';
  if (!data.platform) return 'Platform or channel is required.';
  if (!data.summary) return 'Proposal summary is required.';
  return '';
}

function setWgeOkamiRequestStatus(message, type) {
  const status = document.getElementById('wgeOkamiStatus');

  if (!status) return;

  status.innerText = String(message || '');
  status.classList.remove('is-error', 'is-success');

  if (type === 'error') status.classList.add('is-error');
  if (type === 'success') status.classList.add('is-success');
}

function setWgeOkamiRequestLoading(isLoading) {
  const submitBtn = document.getElementById('wgeOkamiSubmitBtn');

  wgeOkamiRequestInProgress = Boolean(isLoading);

  if (!submitBtn) return;

  submitBtn.disabled = Boolean(isLoading);
  submitBtn.innerText = isLoading ? 'Submitting Request...' : 'Submit Partner Request';
}

function formatWgeOkamiRequestMessage(data) {
  const lines = [
    'Partner & Marketing Request',
    'Name / Brand: ' + data.name,
    'Contact: ' + data.contact,
    'Inquiry Type: ' + data.inquiry_type,
    'Platform / Channel: ' + data.platform
  ];

  if (data.audience_size) lines.push('Audience Size: ' + data.audience_size);
  if (data.preferred_date) lines.push('Preferred Date: ' + data.preferred_date);
  if (data.preferred_time) lines.push('Preferred Time: ' + data.preferred_time);
  if (data.timezone) lines.push('Timezone: ' + data.timezone);

  lines.push('Proposal Summary: ' + data.summary);

  return lines.join('\n').slice(0, WGE_MESSAGE_TEXT_LIMIT);
}

function buildWgeOkamiRequestPayload(data) {
  return {
    source: 'watchtower_ops_concierge',
    session_id: getWgeSessionId(),
    channel: 'general',
    routing_lane: WGE_OKAMI_ROUTING_LANE,
    request_type: WGE_OKAMI_REQUEST_TYPE,
    display_lane: 'OKAMI',
    display_type: 'PARTNER & MARKETING REQUEST',
    customer_message: formatWgeOkamiRequestMessage(data),
    okami_request: data,
    page_url: window.location.href,
    timestamp: Date.now()
  };
}

function showWgeOkamiRequestSuccess(dispatchData, customerMessage) {
  const form = document.getElementById('wgeOkamiRequestForm');
  const success = document.getElementById('wgeOkamiSuccess');
  const statusText = buildWgeDispatchStatusText(dispatchData) || '✓ Partner request delivered to Dispatch';
  const ticketId = dispatchData && dispatchData.ticket_id ? String(dispatchData.ticket_id).trim() : '';

  if (form) form.hidden = true;
  if (success) success.hidden = false;

  pushToChannel('general', customerMessage, 'user', {
    statusText,
    ticketId
  });

  pushToChannel(
    'general',
    'Your Partner & Marketing Request has been received. WatchTower Ops will review the details and follow up through this conversation if the opportunity is a fit.',
    'agent'
  );

  if (shouldRenderWgeReplyImmediately('general')) {
    renderCurrentChannel();
  }
}

async function submitWgeOkamiRequest(event) {
  if (event && typeof event.preventDefault === 'function') {
    event.preventDefault();
  }

  if (wgeOkamiRequestInProgress) return;

  const data = getWgeOkamiRequestData();
  const validationError = validateWgeOkamiRequest(data);

  if (validationError) {
    setWgeOkamiRequestStatus(validationError, 'error');
    return;
  }

  const payload = buildWgeOkamiRequestPayload(data);
  const customerMessage = payload.customer_message;

  setWgeOkamiRequestStatus('Submitting secure partner request...', 'success');
  setWgeOkamiRequestLoading(true);

  try {
    const dispatchData = await sendWgeMessageToBackend(payload);
    setWgeOkamiRequestStatus('', 'success');
    showWgeOkamiRequestSuccess(dispatchData, customerMessage);
    startWgeReplyPolling();
    triggerWgeReplyCheckSoon(1500);
  } catch (error) {
    setWgeOkamiRequestStatus('WatchTower Dispatch is temporarily unavailable. Please wait a moment and try again.', 'error');
  } finally {
    setWgeOkamiRequestLoading(false);
  }
}

function getWgeRoleNotePopover() {
  let popover = document.getElementById('wgeRoleNotePopover');

  if (popover) return popover;

  popover = document.createElement('div');
  popover.id = 'wgeRoleNotePopover';
  popover.className = 'wge-role-note-popover';
  popover.setAttribute('aria-hidden', 'true');
  document.body.appendChild(popover);

  return popover;
}

function getWgeRosterNoteElement(target) {
  if (!target || !target.closest) return null;

  const panel = target.closest('#panel-home-content, .mobile-concierge-panel');
  if (!panel) return null;

  return panel.querySelector('[data-wge-roster-note]');
}

function getWgeDefaultRosterNote(noteEl) {
  if (!noteEl) return 'AMBAR CEO · Escrow & Trade Protection';

  const dataDefault = String(noteEl.dataset.wgeDefaultNote || '').trim();
  if (dataDefault) return dataDefault;

  const currentText = String(noteEl.textContent || '').trim();
  const fallbackText = currentText || 'AMBAR CEO · Escrow & Trade Protection';
  noteEl.dataset.wgeDefaultNote = fallbackText;

  return fallbackText;
}

function clearWgeRosterNoteActiveTargets() {
  document.querySelectorAll('.wge-roster-group.wge-roster-group-extended .wge-has-note.is-note-active').forEach(target => {
    target.classList.remove('is-note-active');
  });
}

function setWgeRosterNoteActiveTarget(target) {
  if (!target || !target.closest) return;

  const group = target.closest('.wge-roster-group.wge-roster-group-extended');
  if (!group) return;

  group.querySelectorAll('.wge-has-note.is-note-active').forEach(item => {
    item.classList.remove('is-note-active');
  });

  target.classList.add('is-note-active');
}

function resetWgeRosterNotes() {
  document.querySelectorAll('[data-wge-roster-note]').forEach(noteEl => {
    const defaultText = getWgeDefaultRosterNote(noteEl);
    noteEl.textContent = defaultText;
    noteEl.classList.remove('is-active');
  });

  clearWgeRosterNoteActiveTargets();
}

function showWgeRosterInlineNote(target, autoHide) {
  if (!target || !target.dataset || !target.dataset.wgeNote) return false;

  const noteEl = getWgeRosterNoteElement(target);
  if (!noteEl) return false;

  const note = String(target.dataset.wgeNote || '').trim();
  if (!note) return true;

  if (wgeRoleNoteHideTimer) {
    window.clearTimeout(wgeRoleNoteHideTimer);
    wgeRoleNoteHideTimer = null;
  }

  getWgeDefaultRosterNote(noteEl);
  noteEl.textContent = note;
  noteEl.classList.add('is-active');
  setWgeRosterNoteActiveTarget(target);

  if (autoHide) {
    wgeRoleNoteHideTimer = window.setTimeout(() => {
      resetWgeRosterNotes();
      wgeRoleNoteHideTimer = null;
    }, WGE_ROLE_NOTE_HIDE_DELAY_MS);
  }

  return true;
}

function hideWgeRoleNote() {
  const popover = document.getElementById('wgeRoleNotePopover');

  if (wgeRoleNoteHideTimer) {
    window.clearTimeout(wgeRoleNoteHideTimer);
    wgeRoleNoteHideTimer = null;
  }

  resetWgeRosterNotes();

  if (!popover) return;

  popover.classList.remove('is-visible');
  popover.setAttribute('aria-hidden', 'true');
}

function showWgeRoleNote(target, autoHide) {
  if (!target || !target.dataset || !target.dataset.wgeNote) return;

  if (showWgeRosterInlineNote(target, autoHide)) {
    return;
  }

  const popover = getWgeRoleNotePopover();
  const rect = target.getBoundingClientRect();
  const note = String(target.dataset.wgeNote || '').trim();

  if (!note) return;

  if (wgeRoleNoteHideTimer) {
    window.clearTimeout(wgeRoleNoteHideTimer);
    wgeRoleNoteHideTimer = null;
  }

  popover.innerText = note;
  popover.style.left = Math.round(rect.left + rect.width / 2) + 'px';
  popover.style.top = Math.round(rect.top - 10) + 'px';
  popover.classList.add('is-visible');
  popover.setAttribute('aria-hidden', 'false');

  if (autoHide) {
    wgeRoleNoteHideTimer = window.setTimeout(() => {
      hideWgeRoleNote();
    }, WGE_ROLE_NOTE_HIDE_DELAY_MS);
  }
}

function isWgeRoleNoteTarget(element) {
  if (!element || !element.matches) return false;

  return Boolean(
    element.matches('.wge-roster-group.wge-roster-group-extended .wge-has-note') &&
    !element.closest('.wge-chat-agents-top')
  );
}

function bindWgeRoleNoteHints() {
  const targets = document.querySelectorAll('.wge-roster-group.wge-roster-group-extended .wge-has-note');

  targets.forEach(target => {
    if (!isWgeRoleNoteTarget(target) || target.dataset.wgeRoleNoteBound === 'true') return;

    target.addEventListener('mouseenter', () => {
      if (!isMobileViewport()) showWgeRoleNote(target, false);
    });

    target.addEventListener('mouseleave', () => {
      if (!isMobileViewport()) hideWgeRoleNote();
    });

    target.addEventListener('focus', () => {
      showWgeRoleNote(target, false);
    });

    target.addEventListener('blur', hideWgeRoleNote);

    target.addEventListener('click', () => {
      if (isMobileViewport()) showWgeRoleNote(target, true);
    });

    target.dataset.wgeRoleNoteBound = 'true';
  });
}

function getWgeOkamiRequestTriggerFromEvent(event) {
  if (!event) return null;

  const selector = '[data-wge-okami-request-trigger="true"], .wge-okami-op-card, .wge-okami-chat-avatar';

  if (event.currentTarget && event.currentTarget.matches && event.currentTarget.matches(selector)) {
    return event.currentTarget;
  }

  if (!event.target || typeof event.target.closest !== 'function') return null;

  return event.target.closest(selector);
}

function triggerWgeOkamiRequestModalFromCard(event) {
  const trigger = getWgeOkamiRequestTriggerFromEvent(event);
  if (!trigger) return;

  if (event && typeof event.preventDefault === 'function') event.preventDefault();
  if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
  if (event && typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

  const now = Date.now();
  if (now - wgeLastOkamiRequestTriggerAt < 420) return;

  wgeLastOkamiRequestTriggerAt = now;
  openWgeOkamiRequestModal();
}

function bindWgeOkamiRequestTriggers() {
  const selector = '[data-wge-okami-request-trigger="true"], .wge-okami-op-card, .wge-okami-chat-avatar';

  document.querySelectorAll(selector).forEach(trigger => {
    if (!trigger || trigger.dataset.wgeOkamiTriggerBound === 'true') return;

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', 'wgeOkamiRequestModal');
    trigger.onclick = null;

    trigger.addEventListener('click', triggerWgeOkamiRequestModalFromCard);
    trigger.addEventListener('touchend', triggerWgeOkamiRequestModalFromCard, { passive: false });
    trigger.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') triggerWgeOkamiRequestModalFromCard(event);
    });

    trigger.dataset.wgeOkamiTriggerBound = 'true';
  });

  if (document.documentElement.dataset.wgeOkamiDelegateBound === 'true') return;

  document.addEventListener('click', event => {
    if (getWgeOkamiRequestTriggerFromEvent(event)) triggerWgeOkamiRequestModalFromCard(event);
  });

  document.addEventListener('touchend', event => {
    if (getWgeOkamiRequestTriggerFromEvent(event)) triggerWgeOkamiRequestModalFromCard(event);
  }, { passive: false });

  document.documentElement.dataset.wgeOkamiDelegateBound = 'true';
}

function bindWgeChatAgentTopCleanControls() {
  document.querySelectorAll('.wge-chat-agents-top img').forEach(target => {
    if (!target) return;

    target.classList.remove('wge-has-note', 'is-note-active');
    target.removeAttribute('data-wge-note');

    if (target.dataset.wgeChatTopCleanBound === 'true') return;

    target.addEventListener('click', hideWgeRoleNote, true);
    target.addEventListener('touchend', hideWgeRoleNote, { capture: true, passive: true });
    target.dataset.wgeChatTopCleanBound = 'true';
  });
}

function openWgeCalendlyPopup() {
  openWgeCalendlyModal();
}

function toggleWgeDashboard() {
  const dashboard = document.getElementById('wgeDashboard');
  const launcher = document.querySelector('.wge-launcher');

  if (!dashboard || !launcher) return;

  dashboard.classList.toggle('is-open');
  launcher.classList.toggle('is-active');

  if (dashboard.classList.contains('is-open')) {
    syncVerifiedAssets();
    preloadWgeCalendlyAssets();
    startWgeReplyPolling();
    triggerWgeReplyCheckSoon(400);

    const chatView = document.getElementById('view-chat');

    if (chatView && chatView.classList.contains('active')) {
      unreadChatCount = 0;
      updateBadges();
      renderCurrentChannel();
    }
  }
}

function updateBadges() {
  const launcherBadge = document.getElementById('launcherBadge');
  const chatMenuBadge = document.getElementById('chatMenuBadge');

  if (!launcherBadge || !chatMenuBadge) return;

  if (unreadChatCount > 0) {
    launcherBadge.innerText = unreadChatCount;
    launcherBadge.style.display = 'flex';

    chatMenuBadge.innerText = unreadChatCount;
    chatMenuBadge.style.display = 'flex';
  } else {
    launcherBadge.style.display = 'none';
    chatMenuBadge.style.display = 'none';
  }
}

function switchView(id, el) {
  document.querySelectorAll('.wge-view').forEach(view => view.classList.remove('active'));
  document.querySelectorAll('.wge-nav-item').forEach(item => item.classList.remove('active'));

  const targetView = document.getElementById(id);
  if (targetView) targetView.classList.add('active');

  if (el) el.classList.add('active');

  const viewTitleEl = document.getElementById('view-title');

  if (id === 'view-chat') {
    unreadChatCount = 0;
    updateBadges();
    updateChatTitle();
    renderCurrentChannel();
    startWgeReplyPolling();
    triggerWgeReplyCheckSoon(400);
  } else if (viewTitleEl) {
    viewTitleEl.innerText = 'Dashboard';
  }

  const homePanel = document.getElementById('panel-home-content');
  const chatPanel = document.getElementById('panel-chat-content');

  if (id === 'view-home') {
    if (homePanel) homePanel.classList.add('active');
    if (chatPanel) chatPanel.classList.remove('active');
  }

  if (id === 'view-chat') {
    if (homePanel) homePanel.classList.remove('active');
    if (chatPanel) chatPanel.classList.add('active');
  }
}

function updateChatTitle() {
  const title = document.getElementById('view-title');
  if (!title) return;

  if (selectedAgent && wgeAgentProfiles[selectedAgent]) {
    const profile = wgeAgentProfiles[selectedAgent];

    title.innerHTML = isMobileViewport()
      ? profile.name + ' Channel'
      : 'OPERATIVE CHANNEL<br>' + profile.name + ' | ' + profile.role;

    return;
  }

  title.innerHTML = isMobileViewport()
    ? 'General Chat'
    : 'OPERATIVE CHANNEL<br>General Support Channel';
}

function getAgentDescription(profile) {
  if (!profile) return '';

  if (isMobileViewport() && !wgeAgentDetailsExpanded) {
    return profile.mobileDescription || profile.description;
  }

  return profile.description;
}

function updateAgentDetailsToggle() {
  const toggle = document.getElementById('agentDetailsToggle') || document.querySelector('.wge-agent-details-toggle');
  const card = document.getElementById('agentInfoCard');

  if (!toggle || !card) return;

  if (!selectedAgent) {
    toggle.style.display = 'none';
    toggle.innerText = 'DETAILS';
    card.classList.remove('is-expanded');
    return;
  }

  toggle.style.display = isMobileViewport() ? 'inline-flex' : 'none';
  toggle.innerText = wgeAgentDetailsExpanded ? 'HIDE DETAILS' : 'DETAILS';

  if (wgeAgentDetailsExpanded) {
    card.classList.add('is-expanded');
  } else {
    card.classList.remove('is-expanded');
  }
}

function updateAgentInfoCard(agentName) {
  const profile = wgeAgentProfiles[agentName];
  const card = document.getElementById('agentInfoCard');
  const avatar = document.getElementById('agentCardAvatar');
  const name = document.getElementById('agentCardName');
  const role = document.getElementById('agentCardRole');
  const desc = document.getElementById('agentCardDesc');

  if (!profile || !card || !avatar || !name || !role || !desc) return;

  avatar.src = profile.avatar;
  avatar.alt = profile.name;
  name.innerText = profile.name;
  role.innerText = profile.title;
  desc.innerText = getAgentDescription(profile);

  card.classList.add('is-visible');

  updateAgentDetailsToggle();
}

function toggleAgentDetails() {
  if (!selectedAgent || !wgeAgentProfiles[selectedAgent]) return;

  wgeAgentDetailsExpanded = !wgeAgentDetailsExpanded;
  updateAgentInfoCard(selectedAgent);
  saveWgeChatState();
}

function selectAgent(agentName) {
  const profile = wgeAgentProfiles[agentName];
  if (!profile) return;

  selectedAgent = agentName;
  currentChannel = agentName;
  wgeAgentDetailsExpanded = false;

  ensureChannelHistory(currentChannel);

  const chatView = document.getElementById('view-chat');

  if (chatView && !chatView.classList.contains('active')) {
    switchView('view-chat', document.querySelectorAll('.wge-nav-item')[1]);
  }

  document.querySelectorAll('.wge-chat-agents-top img').forEach(img => img.classList.remove('active'));

  const targetImg = document.getElementById('avatar-' + agentName);
  if (targetImg) targetImg.classList.add('active');

  updateChatTitle();
  updateAgentInfoCard(agentName);
  renderCurrentChannel();
  saveWgeChatState();
}

function resetToGeneralSupport() {
  selectedAgent = null;
  currentChannel = 'general';
  wgeAgentDetailsExpanded = false;

  ensureChannelHistory(currentChannel);

  document.querySelectorAll('.wge-chat-agents-top img').forEach(img => img.classList.remove('active'));

  const card = document.getElementById('agentInfoCard');
  const avatar = document.getElementById('agentCardAvatar');
  const name = document.getElementById('agentCardName');
  const role = document.getElementById('agentCardRole');
  const desc = document.getElementById('agentCardDesc');

  if (card) {
    card.classList.remove('is-visible');
    card.classList.remove('is-expanded');
  }

  if (avatar) avatar.src = wgeAgentProfiles.Ambar.avatar;
  if (name) name.innerText = 'WATCHTOWER OPS';
  if (role) role.innerText = 'General Support Channel';
  if (desc) desc.innerText = 'Select an operative to review the right support lane before sending your message.';

  updateAgentDetailsToggle();
  updateChatTitle();
  renderCurrentChannel();
  saveWgeChatState();
}

function renderWgeOperatorAttachments(containerId, attachments) {
  const container = document.getElementById(containerId);
  const safeAttachments = sanitizeWgeReplyAttachments(attachments);
  if (!container || safeAttachments.length === 0) return;

  const group = document.createElement('div');
  group.className = 'wge-attachment-batch wge-attachment-batch-operator';

  safeAttachments.forEach(item => {
    const isPreviewableImage = Boolean(
      item.previewUrl &&
      ['image/jpeg', 'image/png', 'image/webp'].includes(item.contentType)
    );

    if (isPreviewableImage) {
      const card = document.createElement('div');
      card.className = 'wge-attachment-card wge-attachment-image-card is-ready';

      const previewLink = document.createElement('a');
      previewLink.className = 'wge-attachment-image-preview-link';
      previewLink.href = item.previewUrl;
      previewLink.target = '_blank';
      previewLink.rel = 'noopener noreferrer';
      previewLink.setAttribute('aria-label', 'Open ' + item.name);

      const image = document.createElement('img');
      image.className = 'wge-attachment-image-preview';
      image.src = item.previewUrl;
      image.alt = item.name;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.addEventListener('error', () => {
        previewLink.remove();
        card.classList.add('is-preview-unavailable');
      }, { once: true });

      previewLink.appendChild(image);
      card.appendChild(previewLink);

      const meta = document.createElement('div');
      meta.className = 'wge-attachment-image-meta';

      const name = document.createElement('div');
      name.className = 'wge-attachment-name';
      name.textContent = item.name;

      const actionRow = document.createElement('div');
      actionRow.className = 'wge-attachment-image-actions';

      const status = document.createElement('div');
      status.className = 'wge-attachment-status';
      status.textContent = 'SECURE & READY';

      const download = document.createElement('a');
      download.className = 'wge-attachment-image-download';
      download.href = item.downloadUrl;
      download.target = '_blank';
      download.rel = 'noopener noreferrer';
      download.textContent = 'DOWNLOAD';

      actionRow.appendChild(status);
      actionRow.appendChild(download);
      meta.appendChild(name);
      meta.appendChild(actionRow);
      card.appendChild(meta);
      group.appendChild(card);
      return;
    }

    const link = document.createElement('a');
    link.className = 'wge-attachment-card wge-attachment-download is-ready';
    link.href = item.downloadUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';

    const name = document.createElement('div');
    name.className = 'wge-attachment-name';
    name.textContent = item.name;

    const status = document.createElement('div');
    status.className = 'wge-attachment-status';
    status.textContent = 'SECURE & READY · DOWNLOAD';

    link.appendChild(name);
    link.appendChild(status);
    group.appendChild(link);
  });

  container.appendChild(group);
  container.scrollTop = container.scrollHeight;
}

function renderCurrentChannel() {
  renderChannelHistory(getActiveChannel());
}

function renderChannelHistory(channelKey) {
  const chatArea = document.getElementById('chatArea');
  if (!chatArea) return;

  const history = ensureChannelHistory(channelKey);

  chatArea.innerHTML = '';

  history.forEach(item => {
    if (String(item.text || '').trim()) {
      appendMsg('chatArea', item, item.type, false);
    }
    if (Array.isArray(item.attachments) && item.attachments.length > 0) {
      renderWgeOperatorAttachments('chatArea', item.attachments);
    }
  });

  chatArea.scrollTop = chatArea.scrollHeight;
}

function pushToChannel(channelKey, text, type, metadata) {
  const key = isWgeValidChannel(channelKey) ? channelKey : getActiveChannel();

  ensureChannelHistory(key);

  const message = sanitizeWgeStoredMessage({
    type: type || 'agent',
    text: text || '',
    timestamp: Date.now(),
    statusText: metadata && metadata.statusText ? metadata.statusText : '',
    ticketId: metadata && metadata.ticketId ? metadata.ticketId : '',
    actions: metadata && Array.isArray(metadata.actions) ? metadata.actions : [],
    attachments: metadata && Array.isArray(metadata.attachments) ? metadata.attachments : []
  });

  if (!message.text.trim() && message.attachments.length === 0) return;

  wgeChannelHistories[key].push(message);
  wgeChannelHistories[key] = trimWgeChannelHistory(wgeChannelHistories[key]);

  saveWgeChatState();
}

const wgeStatTargets = {
  assets: 0,
  shelters: 0,
  currencyIso: 'USD'
};

function formatWgeCurrency(value) {
  const currencyIso = String(wgeStatTargets.currencyIso || 'USD').toUpperCase();
  const zeroDecimalCurrencies = ['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'];
  const fractionDigits = zeroDecimalCurrencies.includes(currencyIso) ? 0 : 2;
  const safeValue = Number(value || 0);

  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyIso,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    }).format(safeValue);
  } catch (error) {
    return '$' + safeValue.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
}

function syncVerifiedAssets() {
  const dashboard = document.getElementById('wgeDashboard');
  if (!dashboard) return;

  const cents = Number(dashboard.dataset.assetCents || 0);
  const count = Number(dashboard.dataset.shelters || 0);
  const currencyIso = String(dashboard.dataset.currencyIso || 'USD').toUpperCase();

  wgeStatTargets.assets = cents / 100;
  wgeStatTargets.shelters = count;
  wgeStatTargets.currencyIso = currencyIso;

  runStatCountUp();
}

function runStatCountUp() {
  const assetsEl = document.getElementById('statAssets');
  const sheltersEl = document.getElementById('statShelters');

  if (!assetsEl || !sheltersEl) return;

  if (sessionStorage.getItem('wge_stats_animated')) {
    assetsEl.textContent = formatWgeCurrency(wgeStatTargets.assets);
    sheltersEl.textContent = wgeStatTargets.shelters + ' Units';
    return;
  }

  sessionStorage.setItem('wge_stats_animated', 'true');

  const duration = 1200;
  const fps = 60;
  const totalFrames = Math.round((duration / 1000) * fps);
  let frame = 0;

  const counter = setInterval(() => {
    frame++;

    const progress = frame / totalFrames;
    const easeProgress = 1 - Math.pow(1 - progress, 3);
    const currentAssets = wgeStatTargets.assets * easeProgress;
    const currentShelters = Math.round(wgeStatTargets.shelters * easeProgress);

    assetsEl.textContent = formatWgeCurrency(currentAssets);
    sheltersEl.textContent = currentShelters + ' Units';

    if (frame >= totalFrames) {
      clearInterval(counter);
      assetsEl.textContent = formatWgeCurrency(wgeStatTargets.assets);
      sheltersEl.textContent = wgeStatTargets.shelters + ' Units';
    }
  }, 1000 / fps);
}

function getWgeAttachmentExtension(name) {
  const safeName = String(name || '').trim().toLowerCase();
  const lastDot = safeName.lastIndexOf('.');
  return lastDot > 0 ? safeName.slice(lastDot) : '';
}

function buildWgeAttachmentRequestId() {
  const randomPart = Math.random().toString(36).slice(2, 10);
  return 'attach_' + Date.now().toString(36) + '_' + randomPart;
}

function sleepWgeAttachment(ms) {
  return new Promise(resolve => window.setTimeout(resolve, ms));
}

function validateWgeAttachmentFiles(files, capabilities) {
  if (!Array.isArray(files) || files.length === 0) return 'Select at least one file.';

  const maxFiles = Math.min(Number(capabilities.max_files || WGE_ATTACHMENT_MAX_FILES), WGE_ATTACHMENT_MAX_FILES);
  const maxFileBytes = Math.min(Number(capabilities.max_file_bytes || WGE_ATTACHMENT_MAX_FILE_BYTES), WGE_ATTACHMENT_MAX_FILE_BYTES);
  const maxTotalBytes = Math.min(Number(capabilities.max_total_bytes || WGE_ATTACHMENT_MAX_TOTAL_BYTES), WGE_ATTACHMENT_MAX_TOTAL_BYTES);
  const allowedTypes = new Set(Array.isArray(capabilities.allowed_content_types) ? capabilities.allowed_content_types : []);

  if (files.length > maxFiles) return 'Maximum ' + maxFiles + ' files per upload.';

  let totalBytes = 0;

  for (const file of files) {
    const contentType = String(file.type || '').trim().toLowerCase();
    const extension = getWgeAttachmentExtension(file.name);
    const allowedExtensions = WGE_ATTACHMENT_ALLOWED_TYPES.get(contentType);

    if (!allowedTypes.has(contentType) || !allowedExtensions || !allowedExtensions.has(extension)) {
      return 'One or more selected files use an unsupported type or extension.';
    }

    if (!Number.isFinite(file.size) || file.size <= 0 || file.size > maxFileBytes) {
      return 'One or more selected files exceed the allowed file size.';
    }

    totalBytes += file.size;
    if (totalBytes > maxTotalBytes) return 'Total attachment size exceeds 40 MiB.';
  }

  return '';
}

async function fetchWgeAttachmentCapabilities() {
  const response = await fetch(WGE_ATTACHMENT_CAPABILITIES_ENDPOINT, {
    method: 'GET',
    headers: { 'Accept': 'application/json' }
  });
  const data = await response.json().catch(() => null);

  if (!response.ok || !data || data.ok !== true) {
    throw new Error('Attachment capability check failed.');
  }

  if (data.upload_available !== true) {
    throw new Error('Secure attachment upload is not available.');
  }

  return data;
}

function createWgeAttachmentBatchUi(container, files) {
  const batch = document.createElement('div');
  batch.className = 'wge-attachment-batch wge-attachment-batch-user';

  const cards = [];
  files.forEach(file => {
    const card = document.createElement('div');
    card.className = 'wge-attachment-card is-uploading';

    const name = document.createElement('div');
    name.className = 'wge-attachment-name';
    name.textContent = file.name;

    const status = document.createElement('div');
    status.className = 'wge-attachment-status';
    status.textContent = 'UPLOADING...';

    card.appendChild(name);
    card.appendChild(status);
    batch.appendChild(card);
    cards.push({ card, status });
  });

  container.appendChild(batch);
  container.scrollTop = container.scrollHeight;
  return cards;
}

function setWgeAttachmentCardState(cardRef, state) {
  if (!cardRef || !cardRef.card || !cardRef.status) return;

  cardRef.card.classList.remove('is-uploading', 'is-scanning', 'is-ready', 'is-rejected', 'is-failed');
  cardRef.card.classList.add('is-' + state);

  const labels = {
    uploading: 'UPLOADING...',
    scanning: 'SECURITY SCAN...',
    ready: 'SECURE & READY',
    rejected: 'REJECTED',
    failed: 'UPLOAD FAILED'
  };

  cardRef.status.textContent = labels[state] || 'UPLOAD FAILED';
}

async function pollWgeAttachmentStatus(prepared, cardRef) {
  const statusPath = String(prepared.status_path || '').trim();
  const accessToken = String(prepared.access_token || '').trim();

  if (!statusPath || !accessToken) {
    setWgeAttachmentCardState(cardRef, 'failed');
    return false;
  }

  const statusUrl = new URL(statusPath, WGE_ATTACHMENT_API_BASE);
  statusUrl.searchParams.set('session_id', getWgeSessionId());

  for (let attempt = 0; attempt < WGE_ATTACHMENT_POLL_MAX_ATTEMPTS; attempt++) {
    const response = await fetch(statusUrl.toString(), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-WGE-Attachment-Token': accessToken
      }
    });
    const data = await response.json().catch(() => null);

    if (!response.ok || !data || data.ok !== true) {
      setWgeAttachmentCardState(cardRef, 'failed');
      return false;
    }

    if (data.public_status === 'ready') {
      setWgeAttachmentCardState(cardRef, 'ready');
      return true;
    }

    if (data.public_status === 'rejected') {
      setWgeAttachmentCardState(cardRef, 'rejected');
      return false;
    }

    if (data.public_status === 'failed') {
      setWgeAttachmentCardState(cardRef, 'failed');
      return false;
    }

    setWgeAttachmentCardState(cardRef, 'scanning');
    await sleepWgeAttachment(WGE_ATTACHMENT_POLL_INTERVAL_MS);
  }

  setWgeAttachmentCardState(cardRef, 'failed');
  return false;
}

async function handleFileUpload(event, containerId) {
  const input = event && event.target ? event.target : null;
  const container = document.getElementById(containerId);
  const files = input ? Array.from(input.files || []) : [];

  if (input) input.value = '';
  if (!container || files.length === 0) return;

  if (wgeAttachmentBatchInProgress) {
    appendMsg(containerId, 'A secure attachment batch is already in progress.', 'system', false);
    return;
  }

  wgeAttachmentBatchInProgress = true;
  const cards = createWgeAttachmentBatchUi(container, files);
  const activeChannel = getActiveChannel();

  try {
    const capabilities = await fetchWgeAttachmentCapabilities();
    const validationError = validateWgeAttachmentFiles(files, capabilities);

    if (validationError) {
      cards.forEach(card => setWgeAttachmentCardState(card, 'rejected'));
      appendMsg(containerId, validationError, 'system', false);
      return;
    }

    const requestId = buildWgeAttachmentRequestId();
    const response = await fetch(WGE_ATTACHMENT_PREPARE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        source: 'watchtower_ops_concierge',
        request_id: requestId,
        session_id: getWgeSessionId(),
        channel: activeChannel,
        page_url: window.location.href,
        files: files.map(file => ({
          name: file.name,
          size_bytes: file.size,
          content_type: String(file.type || '').trim().toLowerCase()
        }))
      })
    });
    const data = await response.json().catch(() => null);

    if (!response.ok || !data || data.ok !== true || !Array.isArray(data.files)) {
      throw new Error(data && data.detail ? String(data.detail) : 'Attachment prepare failed.');
    }

    const preparedByIndex = new Map(data.files.map(item => [Number(item.file_index), item]));

    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      const prepared = preparedByIndex.get(index);

      if (!prepared) {
        setWgeAttachmentCardState(cards[index], 'failed');
        continue;
      }

      if (prepared.public_status === 'ready') {
        setWgeAttachmentCardState(cards[index], 'ready');
        continue;
      }

      const uploadUrl = String(prepared.upload_url || '').trim();
      if (uploadUrl) {
        const requiredHeaders = Object.assign({}, prepared.required_headers || {});
        const uploadResponse = await fetch(uploadUrl, {
          method: 'PUT',
          headers: requiredHeaders,
          body: file
        });

        if (!uploadResponse.ok && uploadResponse.status !== 412) {
          setWgeAttachmentCardState(cards[index], 'failed');
          continue;
        }
      }

      setWgeAttachmentCardState(cards[index], 'scanning');
    }

    await Promise.all(
      files.map((file, index) => {
        const prepared = preparedByIndex.get(index);
        if (!prepared || prepared.public_status === 'ready') return Promise.resolve(true);
        if (cards[index].card.classList.contains('is-failed')) return Promise.resolve(false);
        return pollWgeAttachmentStatus(prepared, cards[index]);
      })
    );

    pushToChannel(
      activeChannel,
      '[ Secure attachment batch submitted · ' + files.length + ' file(s) ]',
      'user',
      { ticketId: data.ticket_id || '' }
    );
  } catch (error) {
    cards.forEach(card => {
      if (!card.card.classList.contains('is-ready') && !card.card.classList.contains('is-rejected')) {
        setWgeAttachmentCardState(card, 'failed');
      }
    });
    appendMsg(containerId, 'Secure attachment upload could not be completed.', 'system', false);
  } finally {
    wgeAttachmentBatchInProgress = false;
  }
}

function buildWgeDispatchPayload(text, channelKey, options) {
  const safeChannel = isWgeValidChannel(channelKey) ? channelKey : 'general';

  const payload = {
    source: 'watchtower_ops_concierge',
    session_id: getWgeSessionId(),
    channel: safeChannel,
    customer_message: String(text || '').slice(0, WGE_MESSAGE_TEXT_LIMIT),
    page_url: window.location.href,
    timestamp: Date.now()
  };

  if (options && options.humanRequested === true) {
    payload.human_requested = true;
  }

  return payload;
}
function setWgeHumanRequestButtonState(state) {
  const button = document.getElementById('wgeHumanRequestBtn');
  if (!button) return;

  button.classList.remove('is-requesting', 'is-requested');
  button.disabled = false;
  button.setAttribute('aria-pressed', 'false');

  if (state === 'requesting') {
    button.classList.add('is-requesting');
    button.disabled = true;
    button.innerText = 'REQUESTING...';
    return;
  }

  if (state === 'requested') {
    button.classList.add('is-requested');
    button.disabled = true;
    button.setAttribute('aria-pressed', 'true');
    button.innerText = 'OPERATOR REQUESTED';
    return;
  }

  button.innerText = 'REQUEST AN OPERATOR';
}

async function requestWgeHumanOperator() {
  if (wgeDispatchInProgress) return;

  const activeChannel = getActiveChannel();

  const requestMessage = 'Customer requested a human WatchTower Ops operator.';

  const payload = buildWgeDispatchPayload(
    requestMessage,
    activeChannel,
    {
      humanRequested: true
    }
  );

  wgeDispatchInProgress = true;
  setWgeHumanRequestButtonState('requesting');

  try {
    const dispatchData = await sendWgeMessageToBackend(payload);

    if (!dispatchData || dispatchData.ok !== true) {
      throw new Error('Human operator request was not confirmed.');
    }

    setWgeHumanRequestButtonState('requested');

    renderWgeDispatchAiReply(dispatchData, activeChannel);

    startWgeReplyPolling();
    triggerWgeReplyCheckSoon(1200);
  } catch (error) {
    setWgeHumanRequestButtonState('idle');

    const fallbackMessage =
      'The operator request could not be delivered. Please wait a moment and try again.';

    pushToChannel(activeChannel, fallbackMessage, 'system');

    if (getActiveChannel() === activeChannel) {
      appendMsg('chatArea', fallbackMessage, 'system', false);
    } else {
      unreadChatCount++;
      updateBadges();
    }
  } finally {
    wgeDispatchInProgress = false;
  }
}

async function sendWgeMessageToBackend(payload) {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => {
    controller.abort();
  }, WGE_DISPATCH_TIMEOUT_MS);

  try {
    const response = await fetch(WGE_DISPATCH_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload),
      signal: controller.signal
    });

    let data = null;

    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }

    if (!response.ok) {
      const detail = data && data.detail ? String(data.detail) : 'WatchTower Dispatch rejected this request.';
      throw new Error(detail);
    }

    if (!data || data.ok !== true) {
      throw new Error('WatchTower Dispatch returned an invalid response.');
    }

    return data;
  } finally {
    window.clearTimeout(timeoutId);
  }
}
function buildWgeDispatchStatusText(dispatchData) {
  if (!dispatchData || dispatchData.ok !== true) {
    return '';
  }

  if (dispatchData.status === 'duplicate_ignored') {
    return '✓ Already delivered to Dispatch moments ago';
  }

  const ticketId = dispatchData.ticket_id ? String(dispatchData.ticket_id).trim() : '';

  if (ticketId) {
    return '✓ Delivered to Dispatch · Ref: ' + ticketId;
  }

  return '✓ Delivered to Dispatch';
}

function renderWgeDispatchAiReply(dispatchData, channelKey) {
  if (!dispatchData || dispatchData.ok !== true) return false;

  const replySource = String(dispatchData.reply_source || '').trim().toLowerCase();
  const aiStatus = String(dispatchData.ai_status || '').trim().toLowerCase();

  if (replySource !== 'ai') {
    return false;
  }

  const replyText = String(dispatchData.reply || '')
    .slice(0, WGE_MESSAGE_TEXT_LIMIT)
    .trim();

  if (!replyText) {
    return false;
  }

  const targetChannel = isWgeValidChannel(channelKey)
    ? channelKey
    : 'general';

  const messageType = aiStatus === 'human_takeover'
  ? 'system'
  : 'ai';

const navigationActions = sanitizeWgeNavigationActions(
  dispatchData.navigation_actions
);

pushToChannel(targetChannel, replyText, messageType, {
  actions: navigationActions
});

if (shouldRenderWgeReplyImmediately(targetChannel)) {
  appendMsg('chatArea', replyText, messageType, false, {
    actions: navigationActions
  });
} else {
    unreadChatCount++;
    updateBadges();
  }

  return true;
}

function updateLatestWgeUserMessageStatus(channelKey, text, statusText, ticketId) {
  const key = isWgeValidChannel(channelKey) ? channelKey : getActiveChannel();
  const history = ensureChannelHistory(key);
  const safeText = String(text || '');
  const safeStatusText = String(statusText || '').trim();
  const safeTicketId = String(ticketId || '').trim();

  if (!safeStatusText || history.length === 0) return false;

  for (let i = history.length - 1; i >= 0; i--) {
    const item = history[i];

    if (!item || item.type !== 'user') continue;
    if (item.ticketId) continue;
    if (String(item.text || '') !== safeText) continue;

    item.statusText = safeStatusText;
    item.ticketId = safeTicketId;
    wgeChannelHistories[key] = trimWgeChannelHistory(history);
    saveWgeChatState();

    if (shouldRenderWgeReplyImmediately(key)) {
      renderCurrentChannel();
    }

    return true;
  }

  return false;
}
async function callLLM(text, systemPrompt, channelKey) {
  const payload = buildWgeDispatchPayload(text, channelKey);
  return await sendWgeMessageToBackend(payload);
}

function appendMsg(containerId, text, type, saveToHistory, metadata) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const isMessageObject = text && typeof text === 'object';
  const message = sanitizeWgeStoredMessage(
    isMessageObject
      ? text
      : {
          type: type || 'agent',
          text: text || '',
          timestamp: Date.now(),
          statusText: metadata && metadata.statusText ? metadata.statusText : '',
          ticketId: metadata && metadata.ticketId ? metadata.ticketId : '',
          actions: metadata && Array.isArray(metadata.actions)
            ? metadata.actions
            : []
        }
  );

  const bubble = document.createElement('div');
  bubble.className = 'wge-bubble wge-' + message.type;

  if (message.type === 'document') {
    const pre = document.createElement('pre');
    pre.style.whiteSpace = 'pre-wrap';
    pre.style.fontFamily = 'monospace';
    pre.style.margin = '0';
    pre.textContent = message.text;
    bubble.appendChild(pre);
  } else {
    bubble.innerText = message.text;
  }

  if (message.statusText && message.type === 'user') {
    const wrap = document.createElement('div');
    wrap.className = 'wge-message-wrap wge-user-wrap';

    const status = document.createElement('div');
    status.className = 'wge-message-status';
    status.innerText = message.statusText;

    wrap.appendChild(bubble);
    wrap.appendChild(status);
    container.appendChild(wrap);
  } else if (
    message.type === 'ai' &&
    Array.isArray(message.actions) &&
    message.actions.length > 0
  ) {
    const wrap = document.createElement('div');
    wrap.className = 'wge-message-wrap wge-ai-wrap';

    const actionRow = document.createElement('div');
    actionRow.className = 'wge-message-actions';

    message.actions.forEach((action, index) => {
      const link = document.createElement('a');

      link.className =
        'wge-message-cta ' +
        (index === 0 ? 'is-primary' : 'is-secondary');

      link.href = action.url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = action.label;

      actionRow.appendChild(link);
    });

    wrap.appendChild(bubble);
    wrap.appendChild(actionRow);
    container.appendChild(wrap);
  } else {
    container.appendChild(bubble);
  }

  container.scrollTop = container.scrollHeight;

  if (saveToHistory !== false) {
    pushToChannel(getActiveChannel(), message.text, message.type, {
      statusText: message.statusText,
      ticketId: message.ticketId,
      actions: message.actions
    });
  }
}

function startTyping(id) {
  const container = document.getElementById(id);
  if (!container) return;

  stopTyping();

  const bubble = document.createElement('div');
  bubble.className = 'wge-bubble wge-agent';
  bubble.id = 'typing';

  const loaderWrap = document.createElement('div');
  loaderWrap.style.display = 'flex';
  loaderWrap.style.gap = '6px';

  for (let i = 0; i < 3; i++) {
    const dot = document.createElement('div');
    dot.className = 'wge-dot-loader';
    dot.style.animationDelay = i * 0.2 + 's';
    loaderWrap.appendChild(dot);
  }

  bubble.appendChild(loaderWrap);
  container.appendChild(bubble);
  container.scrollTop = container.scrollHeight;
}

function stopTyping() {
  const typing = document.getElementById('typing');
  if (typing) typing.remove();
}

function submitQuickInquiry(isMobile) {
  const inputId = isMobile ? 'hqQuickInputMobile' : 'hqQuickInput';
  const input = document.getElementById(inputId);

  if (!input) return;

  const text = input.value.trim();
  if (!text) return;

  resetToGeneralSupport();
  switchView('view-chat', document.querySelectorAll('.wge-nav-item')[1]);

  const chatInput = document.getElementById('chatIn');
  if (chatInput) chatInput.value = text;

  input.value = '';
  sendChat('chat');
}

async function sendChat() {
  if (wgeDispatchInProgress) return;

  const input = document.getElementById('chatIn');

  if (!input) return;

  const text = input.value.trim();
  if (!text) return;

  const activeChannel = getActiveChannel();

  wgeDispatchInProgress = true;

  pushToChannel(activeChannel, text, 'user');
  appendMsg('chatArea', text, 'user', false);

  input.value = '';
  startTyping('chatArea');

try {
  const dispatchData = await callLLM(text, 'WatchTower Ops secure routing assistant.', activeChannel);
  const statusText = buildWgeDispatchStatusText(dispatchData);
  const ticketId = dispatchData && dispatchData.ticket_id ? String(dispatchData.ticket_id).trim() : '';

  stopTyping();

  if (statusText) {
    updateLatestWgeUserMessageStatus(activeChannel, text, statusText, ticketId);
  }

  renderWgeDispatchAiReply(dispatchData, activeChannel);

  startWgeReplyPolling();
  triggerWgeReplyCheckSoon(1500);
} catch (error) {
    const fallbackMessage = 'WatchTower Dispatch is temporarily unavailable. Your message was not delivered. Please wait a moment and try again.';

    pushToChannel(activeChannel, fallbackMessage, 'agent');

    if (getActiveChannel() === activeChannel) {
      appendMsg('chatArea', fallbackMessage, 'agent', false);
    } else {
      unreadChatCount++;
      updateBadges();
    }
  } finally {
    stopTyping();
    wgeDispatchInProgress = false;
  }

  const dashboard = document.getElementById('wgeDashboard');
  const chatView = document.getElementById('view-chat');
  const isChatActive = chatView && chatView.classList.contains('active');

  if (!dashboard || !dashboard.classList.contains('is-open') || !isChatActive) {
    unreadChatCount++;
    updateBadges();
  }
}

async function optimizePrompt() {
  if (optimizePrompt.inProgress) return;

  const input = document.getElementById('chatIn');
  if (!input) return;

  const originalValue = String(input.value || '');
  const draftMessage = originalValue.trim();

  if (!draftMessage) return;

  const button = document.querySelector('.wge-ai-actions .wge-ai-btn');
  const defaultLabel = '✨ REFINE MESSAGE';
  const capabilityEndpoint = 'https://api.thewatchtowerops.com/message-refine/capabilities';
  const refineEndpoint = 'https://api.thewatchtowerops.com/message-refine';

  let feedbackLabel = '';
  let feedbackDurationMs = 0;

  if (optimizePrompt.feedbackTimer) {
    window.clearTimeout(optimizePrompt.feedbackTimer);
    optimizePrompt.feedbackTimer = null;
  }

  const fetchJson = async (url, options, timeoutMs) => {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => {
      controller.abort();
    }, timeoutMs);

    try {
      const response = await fetch(url, {
        ...options,
        signal: controller.signal
      });

      const data = await response.json().catch(() => null);

      if (!response.ok || !data || typeof data !== 'object') {
        throw new Error('Message refinement request failed.');
      }

      return data;
    } finally {
      window.clearTimeout(timeoutId);
    }
  };

  optimizePrompt.inProgress = true;

  if (button) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.innerText = 'REFINING...';
  }

  try {
    const capabilities = await fetchJson(
      capabilityEndpoint,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      },
      6000
    );

    const backendMaxChars = Number(capabilities.max_chars);

    if (
      capabilities.ok !== true ||
      capabilities.auto_send !== false ||
      !Number.isInteger(backendMaxChars) ||
      backendMaxChars < 1
    ) {
      throw new Error('Invalid message refinement capabilities.');
    }

    const effectiveMaxChars = Math.min(
      backendMaxChars,
      WGE_MESSAGE_TEXT_LIMIT
    );

    if (draftMessage.length > effectiveMaxChars) {
      feedbackLabel = 'DRAFT TOO LONG';
      feedbackDurationMs = 1600;
      return;
    }

    if (capabilities.available !== true) {
      feedbackLabel = 'REFINE UNAVAILABLE';
      feedbackDurationMs = 1600;
      return;
    }

    const result = await fetchJson(
      refineEndpoint,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          source: 'watchtower_ops_concierge',
          session_id: getWgeSessionId(),
          draft_message: draftMessage,
          page_url: window.location.href
        })
      },
      12000
    );

    const refinedMessage = typeof result.refined_message === 'string'
      ? result.refined_message.trim()
      : '';

    if (
      result.ok !== true ||
      result.meaning_preserved !== true ||
      result.language_preserved !== true ||
      typeof result.changed !== 'boolean' ||
      !refinedMessage ||
      refinedMessage.length > effectiveMaxChars
    ) {
      throw new Error('Invalid message refinement response.');
    }

    if (String(input.value || '') !== originalValue) {
      feedbackLabel = 'DRAFT CHANGED';
      feedbackDurationMs = 1600;
      return;
    }

    input.value = refinedMessage;
    input.focus();
  } catch (error) {
    feedbackLabel = 'REFINE UNAVAILABLE';
    feedbackDurationMs = 1600;
  } finally {
    optimizePrompt.inProgress = false;

    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.innerText = feedbackLabel || defaultLabel;

      if (feedbackDurationMs > 0) {
        optimizePrompt.feedbackTimer = window.setTimeout(() => {
          if (!optimizePrompt.inProgress) {
            button.innerText = defaultLabel;
          }

          optimizePrompt.feedbackTimer = null;
        }, feedbackDurationMs);
      }
    }
  }
}

function handleEnter(e, mode) {
  if (e.key === 'Enter') {
    if (mode === 'chat') sendChat();
  }
}

function bindWgeCommandCenterControls() {
  const detailsToggle = document.getElementById('agentDetailsToggle') || document.querySelector('.wge-agent-details-toggle');
  const generalBtn = document.getElementById('agentGeneralButton') || document.querySelector('.wge-general-support-btn');
  const humanRequestBtn = document.getElementById('wgeHumanRequestBtn');

  if (detailsToggle) {
    detailsToggle.onclick = null;

    if (!detailsToggle.dataset.wgeBound) {
      detailsToggle.addEventListener('click', toggleAgentDetails);
      detailsToggle.dataset.wgeBound = 'true';
    }
  }

  if (generalBtn) {
    generalBtn.onclick = null;

    if (!generalBtn.dataset.wgeBound) {
      generalBtn.addEventListener('click', resetToGeneralSupport);
      generalBtn.dataset.wgeBound = 'true';
    }
  }
  if (humanRequestBtn) {
  humanRequestBtn.onclick = null;

  if (!humanRequestBtn.dataset.wgeBound) {
    humanRequestBtn.addEventListener('click', requestWgeHumanOperator);
    humanRequestBtn.dataset.wgeBound = 'true';
  }
}

  updateAgentDetailsToggle();
}

window.addEventListener('resize', () => {
  hideWgeRoleNote();
  bindWgeRoleNoteHints();
  bindWgeChatAgentTopCleanControls();
  updateChatTitle();

  if (selectedAgent) {
    updateAgentInfoCard(selectedAgent);
  } else {
    updateAgentDetailsToggle();
  }
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    closeWgeCalendlyModal();
    closeWgeOkamiRequestModal();
    hideWgeRoleNote();
  }
});
document.addEventListener('visibilitychange', () => {
  if (!document.hidden && wgeReplyPollingTimer) {
    fetchWgeOperatorReplies();
  }
});

window.openWgeOkamiRequestModal = openWgeOkamiRequestModal;
window.closeWgeOkamiRequestModal = closeWgeOkamiRequestModal;
window.submitWgeOkamiRequest = submitWgeOkamiRequest;

function initializeWgeCommandCenter() {
  bindWgeCommandCenterControls();
  bindWgeRoleNoteHints();
  bindWgeChatAgentTopCleanControls();
  bindWgeOkamiRequestTriggers();
  resetWgeOkamiRequestForm();
  restoreWgeChatState();

  if (isWgeDashboardOpen() || isWgeChatViewActive()) {
    startWgeReplyPolling();
    triggerWgeReplyCheckSoon(500);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWgeCommandCenter);
} else {
  initializeWgeCommandCenter();
}